import { combineReducers } from "@reduxjs/toolkit";

import bdmsEntity from "../entities/bdms";

export default combineReducers({
  [bdmsEntity.name]: bdmsEntity.reducer,
});
